module.exports = __webpack_public_path__ + "img/sc.d2583fbf.svg";